import { Booking } from './booking';
import { Vademecum } from './vademecum';

export class BrugesVndBooking extends Booking {

    // public studentPicture!: Blob;
    public vademecum!: Vademecum;
}
